module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "custom-home-footer-review",
    attrs: {
      "id": "first"
    }
  }, [_c('div', {
    staticClass: "custom-home-footer-review__container"
  }, [_c('a', {
    staticClass: "custom-home-footer-review__button",
    attrs: {
      "href": "https://search.google.com/local/writereview?placeid=ChIJF5_x57Yv0YkRAxAGy1qUPFw",
      "target": "_blank"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.props.button_text)
    }
  })]), _c('div', {
    staticClass: "custom-home-footer-review__invisalign"
  }, [_c('div', {
    staticClass: "custom-home-footer-review__invisalignwrap"
  }, [_c('div', {
    staticClass: "reviews_diamond",
    domProps: {
      "innerHTML": _vm._s(_vm.props.diamond_plus_intro)
    }
  }), _c('div', {
    staticClass: "custom-home-footer-review__read-more"
  }, [_c('div', {
    staticClass: "customclick",
    on: {
      "click": function($event) {
        return _vm.welcome1Click()
      }
    }
  }, [_vm._v("Read More      ")])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-42118245","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/custom/custom-home-footer-review/custom-home-footer-review.pug
// module id = 699
// module chunks = 1